function initCreditCardsSidebarDrawer() {
    const drawer = document.getElementById('cc-sidebar-drawer');

    if (!drawer) {
        return;
    }

    const trigger = document.querySelector('.cc-sidebar-drawer-trigger');
    const closeBtn = drawer.querySelector('.cc-sidebar-drawer-close');
    const overlay = drawer.querySelector('.cc-sidebar-drawer-overlay');
    const panel = drawer.querySelector('.cc-sidebar-drawer-panel');
    const navLinks = drawer.querySelectorAll('.cc-page-nav-link');
    const closeTransitionMs = 350;

    let closeTimer = null;

    function clearPendingClose() {
        if (!closeTimer) {
            return;
        }

        window.clearTimeout(closeTimer);
        closeTimer = null;
    }

    function openDrawer() {
        clearPendingClose();

        drawer.classList.remove('is-closing');
        drawer.classList.add('is-open');
        drawer.setAttribute('aria-hidden', 'false');
        trigger?.setAttribute('aria-expanded', 'true');
        document.body.classList.add('lock-scrolling');
        closeBtn?.focus();
    }

    function resetDrawerAfterClose() {
        drawer.classList.remove('is-closing');
        document.body.classList.remove('lock-scrolling');
        trigger?.focus();
    }

    function waitForCloseTransition(callback) {
        if (!panel) {
            callback();
            return;
        }

        let hasFinishedClosing = false;

        function finishOnce() {
            if (hasFinishedClosing) {
                return;
            }

            hasFinishedClosing = true;
            closeTimer = null;
            panel.removeEventListener('transitionend', handleTransitionEnd);
            callback();
        }

        function handleTransitionEnd(event) {
            if (event.target === panel && event.propertyName === 'transform') {
                finishOnce();
            }
        }

        panel.addEventListener('transitionend', handleTransitionEnd);
        closeTimer = window.setTimeout(finishOnce, closeTransitionMs + 50);
    }

    function forceCloseDrawer() {
        clearPendingClose();
        drawer.classList.remove('is-open', 'is-closing');
        drawer.setAttribute('aria-hidden', 'true');
        trigger?.setAttribute('aria-expanded', 'false');
        document.body.classList.remove('lock-scrolling');
    }

    function closeDrawer() {
        if (!drawer.classList.contains('is-open')) {
            return;
        }

        drawer.classList.add('is-closing');
        drawer.classList.remove('is-open');
        drawer.setAttribute('aria-hidden', 'true');
        trigger?.setAttribute('aria-expanded', 'false');

        waitForCloseTransition(resetDrawerAfterClose);
    }

    function handleResize() {
        if (window.matchMedia('(min-width: 992px)').matches
            && (drawer.classList.contains('is-open') || drawer.classList.contains('is-closing'))) {
            forceCloseDrawer();
        }
    }

    trigger?.addEventListener('click', openDrawer);
    closeBtn?.addEventListener('click', closeDrawer);
    overlay?.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
            closeDrawer();
        }
    });

    navLinks.forEach((link) => {
        link.addEventListener('click', closeDrawer);
    });

    window.addEventListener('resize', handleResize);
}

document.addEventListener('DOMContentLoaded', initCreditCardsSidebarDrawer);
